<ng-template #modalTemplate>
   <div class="modal-header">
      <h4 class="modal-title pull-left">{{ 'Item details' | translate }}</h4>
   </div>
   <div class="modal-body">
      <p *ngIf="item?.origTaskId">
         <b>{{ 'Original task ID' | translate }}:</b> {{ item.origTaskId }}
      </p>
      <p *ngIf="item?.decommRsn">
         <b>{{ 'Reason' | translate }}:</b> {{ item.decommRsn }}
      </p>
      <p *ngIf="item?.origRecId">
         <b>{{ 'Original record ID' | translate }}:</b> {{ item.origRecId }}
      </p>
      <p *ngIf="item?.origUserId">
         <b>{{ 'Original username' | translate }}:</b> {{ item.origUserId }}
      </p>
      <p *ngIf="item?.actionDate">
         <b>{{ 'Decommission date' | translate }}:</b> {{ item.actionDate }}
      </p>
   </div>
   <div class="modal-footer">
      <button class="btn btn-primary" (click)="close()">{{ 'Close' | translate }}</button>
   </div>
</ng-template>
